export const FILTER_SET_MODEL = {
  ID: 'id',
  NAME: 'name',
  TYPE: 'type',
  VISIBILITY: 'visibility',
  METADATA: {
    DUE_DATE: 'due_date',
    AUTH_SCOPES: {
      TEAM_IDS: 'team_ids'
    }
  },
  OWNER_NAME: 'owner_name',
  ACCOUNT_ID: 'account_id',
  FILTERS: 'filters',
  PDT_ID: 'pdt_id'
};
